module.exports = __webpack_public_path__ + "static/media/quinco_mental2.93cc4700.jpg";